<agpr-dialog-container
    [id]="'alert_mention_create_dialog'"
    [heading]="heading"
    (close)="cancel()"
>
    <div
        class="agpr-alertMentionCreateDialog"
        [style.width]="width + 'rem'"
    >
        <div
            *ngFor="let alertType of alertTypes"
            class="agpr-alertMentionCreateDialog-container"
        >
            <agpr-button
                [style]="buttonTypes.link"
                (click)="setNewAlertType(alertType)"
            >
                <div class="agpr-alertMentionCreateDialog-section">
                    <div class="agpr-alertMentionCreateDialog-section-icon">
                        <span
                            role="img"
                            class="{{alertType.icon}}"
                        ></span>
                    </div>
                    <div>
                        <div class="agpr-alertMentionCreateDialog-section-title">
                            {{ alertType.title | localize }}
                        </div>
                        <div class="agpr-alertMentionCreateDialog-section-message">
                            {{ alertType.message | localize }}
                        </div>
                    </div>
                </div>
            </agpr-button>

            @if (alertType.type === alertTypeEnum.SURGE) {
                @if (hasCoverageInsightsEnabled) {
                    <div class="agpr-alertMentionCreateDialog-surgeInsights">
                        <div class="agpr-alertMentionCreateDialog-surgeInsights-content">
                            <span class="agpr-alertMentionCreateDialog-surgeInsights-icon fa-kit-duotone fa-agpr-insights"></span>
                            <span class="agpr-alertMentionCreateDialog-surgeInsights-label">
                                {{ 'Alerts.surgeInsights.label' | localize }}
                            </span>
                            <span
                                role="img"
                                class="agpr-alertMentionCreateDialog-surgeInsights-infoIcon fa-regular fa-circle-info"
                                [agprTooltip]="'Alerts.surgeInsights.info' | localize"
                            ></span>
                        </div>
                        <agpr-social-switch
                            [(ngModel)]="enableSurgeInsights"
                            [id]="id + '_surgeInsights_switch'"
                            [stopPropagation]="false"
                        ></agpr-social-switch>
                    </div>
                } @else {
                    <div class="agpr-alertMentionCreateDialog-surgeInsights agpr-alertMentionCreateDialog-surgeInsights--locked">
                        <div class="agpr-alertMentionCreateDialog-surgeInsights-content">
                            <span class="agpr-alertMentionCreateDialog-surgeInsights-icon fa-kit-duotone fa-agpr-insights"></span>
                            <span class="agpr-alertMentionCreateDialog-surgeInsights-label">
                                {{ 'Alerts.surgeInsights.label' | localize }}
                            </span>
                            <span
                                role="img"
                                class="agpr-alertMentionCreateDialog-surgeInsights-infoIcon fa-regular fa-circle-info"
                                [agprTooltip]="'Alerts.surgeInsights.info' | localize"
                            ></span>
                        </div>
                        <span
                            class="agpr-alertMentionCreateDialog-surgeInsights-lock fa-solid fa-lock"
                            aria-hidden="true"
                            [agprTooltip]="'Mention.coverage.insights.upsell.heading' | localize"
                            (click)="openUpsell($event)"
                        ></span>
                    </div>
                }
            }
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            id="textInput.cancelButton"
            (click)="cancel()"
            [label]="cancelLabel"
            [style]="buttonTypes.secondary"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
